module.exports = __webpack_public_path__ + "static/media/board.87498ccf.svg";